<account-back>{{'Stock Level' | translate}}</account-back>

<div class="_account-section-grid w-10 w-12-m w-12-s">
    @for (item of content?.items; track $index; let i = $index) {
    <section2 [sectionTitle]="item.title"
              class="block height-100">
        <p class="p1 col-11"
           *iCms="'description' of item; content: 'html'; skipEmpty: true"></p>
        @if (item.links?.length) {
        @for (link of item.links; track $index) {
        <href [link]="link.url"
              class="block m-t-6">
            <button class="button-inline-2"><span *iCms="'linkText' of link;"></span></button>
        </href>
        }
        }
        @if (item.displayButtton) {
        <a class="button m-t-7"
           [attr.href]="mediaFeedUrl">
            {{'Download stock level report' | translate}}
        </a>
        }
    </section2>
    }
</div>